import React from 'react';
import PropTypes from 'prop-types';
import CustomButton from "../../../../../components/CustomButton";
import {MarketplaceRoutes} from "../../../../../utils/MarketplaceRoutes";
import {Link} from "react-router-dom";

MappingMissingButton.propTypes = {
    retailer: PropTypes.object
};

function MappingMissingButton({retailer}) {
    if (!retailer) {
        return null
    }

    return (
        <Link to={MarketplaceRoutes.RETAILER_ATTRIBUTES_MAPPING(retailer.id)}>
            <CustomButton variant={'transparent'} color={'default'}>
                <div style={{marginRight: '24px'}}>
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                         stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"
                         className="lucide lucide-triangle-alert h-4 w-4 mr-2">
                        <path d="m21.73 18-8-14a2 2 0 0 0-3.48 0l-8 14A2 2 0 0 0 4 21h16a2 2 0 0 0 1.73-3"></path>
                        <path d="M12 9v4"></path>
                        <path d="M12 17h.01"></path>
                    </svg>
                </div>
                <span>Mappings manquants ({retailer.missingMappings})</span>
            </CustomButton>
        </Link>
    );
}

export default MappingMissingButton;
